package com.gsb.vyapar.bhagya.presentation.business.view

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.captureImage
import com.gsb.vyapar.bhagya.domain.Categories.D.Category
import com.gsb.vyapar.bhagya.domain.SubCategories
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.interactor.util.hideLoading
import com.gsb.vyapar.bhagya.interactor.util.resizeImage
import com.gsb.vyapar.bhagya.interactor.util.rotateLeft
import com.gsb.vyapar.bhagya.interactor.util.rotateRight
import com.gsb.vyapar.bhagya.interactor.util.showLoading
import com.gsb.vyapar.bhagya.interactor.util.uploadImage
import com.gsb.vyapar.bhagya.presentation.auth.util.chooseImage
import com.gsb.vyapar.bhagya.presentation.auth.util.isUserAdmin
import com.gsb.vyapar.bhagya.presentation.business.util.addBusinessUI
import com.gsb.vyapar.bhagya.presentation.business.util.deleteBusinessPopup
import com.gsb.vyapar.bhagya.presentation.business.util.deleteMBusinessUI
import com.gsb.vyapar.bhagya.presentation.business.util.getLocation
import com.gsb.vyapar.bhagya.presentation.business.util.isMyBusiness
import com.gsb.vyapar.bhagya.presentation.business.util.undoDeleteBusinessPopup
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButtonESmall
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButtonSmall
import com.gsb.vyapar.bhagya.presentation.common.edittext.*
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.menu.OutlinedExpandedMenu
import com.gsb.vyapar.bhagya.presentation.common.menu.OutlinedExpandedSelectMenu
import com.gsb.vyapar.bhagya.presentation.common.platformImePadding
import com.gsb.vyapar.bhagya.presentation.common.text.Text14Regular
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.presentation.common.toolbar.ToolbarDelete
import com.gsb.vyapar.bhagya.presentation.location.util.getDeviceLocationForBusiness
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.close
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.rotateleft
import com.gsb.vyapar.bhagya.theme.rotateright
import com.gsb.vyapar.bhagya.toComposeImageBitmap
import com.gsb.vyapar.bhagya.util.ADD_URL
import com.gsb.vyapar.bhagya.util.getPrivacyUrl
import com.gsb.vyapar.bhagya.util.getTermsUrl
import com.gsb.vyapar.bhagya.util.orEmpty
import com.gsb.vyapar.bhagya.util.value
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import kotlinx.coroutines.launch

@Composable
fun AddEditBusinessView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val uriHandler = LocalUriHandler.current
    var logo by remember { mutableStateOf("") }
    var logoFile: Pair<ByteArray, String>? by remember { mutableStateOf(null) }
    var name by remember { mutableStateOf("") }
    var category by remember { mutableStateOf(Category()) }
    var subCategories = listOf<SubCategories.D.SubCategory>()
    var description by remember { mutableStateOf("") }
    var services by remember { mutableStateOf("") }
    var address by remember { mutableStateOf("") }
    var pincode by remember { mutableStateOf("") }
    var latitude by remember { mutableStateOf("") }
    var longitude by remember { mutableStateOf("") }
    var image1 by remember { mutableStateOf("") }
    var imageFile1: Pair<ByteArray, String>? by remember { mutableStateOf(null) }
    var image2 by remember { mutableStateOf("") }
    var imageFile2: Pair<ByteArray, String>? by remember { mutableStateOf(null) }
    var image3 by remember { mutableStateOf("") }
    var imageFile3: Pair<ByteArray, String>? by remember { mutableStateOf(null) }
    var image4 by remember { mutableStateOf("") }
    var imageFile4: Pair<ByteArray, String>? by remember { mutableStateOf(null) }
    var image5 by remember { mutableStateOf("") }
    var imageFile5: Pair<ByteArray, String>? by remember { mutableStateOf(null) }
    var email by remember { mutableStateOf("") }
    var phone1 by remember { mutableStateOf("") }
    var phone2 by remember { mutableStateOf("") }
    var website by remember { mutableStateOf("") }
    var gmap by remember { mutableStateOf("") }
    var fb by remember { mutableStateOf("") }
    var insta by remember { mutableStateOf("") }
    var x by remember { mutableStateOf("") }
    var linkedIn by remember { mutableStateOf("") }
    var youtube by remember { mutableStateOf("") }
    var selectedIndex by remember { mutableStateOf(-1) }
    var selectedIndices by remember { mutableStateOf(listOf<Int>()) }
    val coroutineScope = rememberCoroutineScope()
    var isAdd by remember { mutableStateOf(name.isEmpty()) }
    val imagePickerLauncher = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        if (selectedImage != null) {
            launchDefault {
                logoFile = Pair(resizeImage(selectedImage.readBytes().orEmpty()), selectedImage.name)
                hideLoading()
            }
        } else {
            hideLoading()
        }
    }
    val imagePickerLauncher1 = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        if (selectedImage != null) {
            launchDefault {
                imageFile1 = Pair(resizeImage(selectedImage.readBytes().orEmpty()), selectedImage.name)
                hideLoading()
            }
        } else {
            hideLoading()
        }
    }
    val imagePickerLauncher2 = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        if (selectedImage != null) {
            launchDefault {
                imageFile2 = Pair(resizeImage(selectedImage.readBytes().orEmpty()), selectedImage.name)
                hideLoading()
            }
        } else {
            hideLoading()
        }
    }
    val imagePickerLauncher3 = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        if (selectedImage != null) {
            launchDefault {
                imageFile3 = Pair(resizeImage(selectedImage.readBytes().orEmpty()), selectedImage.name)
                hideLoading()
            }
        } else {
            hideLoading()
        }
    }
    val imagePickerLauncher4 = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        if (selectedImage != null) {
            launchDefault {
                imageFile4 = Pair(resizeImage(selectedImage.readBytes().orEmpty()), selectedImage.name)
                hideLoading()
            }
        } else {
            hideLoading()
        }
    }
    val imagePickerLauncher5 = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        if (selectedImage != null) {
            launchDefault {
                imageFile5 = Pair(resizeImage(selectedImage.readBytes().orEmpty()), selectedImage.name)
                hideLoading()
            }
        } else {
            hideLoading()
        }
    }
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            if (isMyBusiness(uiState.businessUiState.addEditBusiness) && !uiState.businessUiState.addEditBusiness.isBusinessDeleted()) {
                ToolbarDelete(if (isAdd) "Add Business" else "Edit Business") {
                    deleteBusinessPopup {
                        val masterList = category.getSubCategoriesList(uiState.getSubCategories())
                        subCategories = selectedIndices.mapNotNull { masterList.getOrNull(it) }
                        addBusinessUI(false, logo, name, category, subCategories, description, services, address, pincode, latitude, longitude, image1, image2, image3, image4, image5, email, phone1, phone2, website, gmap, fb, insta, x, linkedIn, youtube, true)
                    }
                }
            } else {
                Toolbar(if (isAdd) "Add Business" else "Edit Business")
            }
            Column(
                modifier = Modifier
                    .verticalScroll(rememberScrollState())
                    .fillMaxWidth()
                    .padding(16.dp)
                    .platformImePadding(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(Modifier.height(8.dp))
                uiState.getImage(logo.ifEmpty { ADD_URL.value() })?.let { imageBitmap ->
                    CommonImage(imageBitmap, 100.dp, 100.dp, Modifier.clickable {
                        if (!uiState.businessUiState.addEditBusiness.isBusinessDeleted()) {
                            chooseImage({
                                showLoading()
                                coroutineScope.launch {
                                    val selectedImage = captureImage()
                                    if (selectedImage != null) {
                                        launchDefault {
                                            logoFile = Pair(resizeImage(selectedImage), "File")
                                            hideLoading()
                                        }
                                    } else {
                                        hideLoading()
                                    }
                                }
                            }, {
                                imagePickerLauncher.launch()
                                showLoading()
                            })
                        }
                    })
                }?: PlaceHolder(modifier = Modifier.clickable {
                    if (!uiState.businessUiState.addEditBusiness.isBusinessDeleted()) {
                        chooseImage({
                            showLoading()
                            coroutineScope.launch {
                                val selectedImage = captureImage()
                                if (selectedImage != null) {
                                    launchDefault {
                                        logoFile = Pair(resizeImage(selectedImage), "File")
                                        hideLoading()
                                    }
                                } else {
                                    hideLoading()
                                }
                            }
                        }, {
                            imagePickerLauncher.launch()
                            showLoading()
                        })
                    }
                })
                Spacer(Modifier.height(4.dp))
                Text14Regular("Select Business Logo / Picture *", black)
                Spacer(Modifier.height(8.dp))
                BusinessNameEditText(name, !uiState.businessUiState.addEditBusiness.isBusinessDeleted()) { name = it }
                if (!uiState.businessUiState.addEditBusiness.isBusinessDeleted()) {
                    Spacer(Modifier.height(8.dp))
                    OutlinedExpandedMenu("Select the Category *", uiState.getCategories().getCategoriesList().map { it.name }, selectedIndex) { selected, index ->
                        selectedIndex = index
                        category = uiState.getCategories().getCategoriesList().find { it.name ==  selected} ?: Category()
                    }
                    Spacer(Modifier.height(8.dp))
                    OutlinedExpandedSelectMenu("Select the SubCategory *", category.getSubCategoriesList(uiState.getSubCategories()).map { it.name }, selectedIndices) { indices ->
                        selectedIndices = indices
                        val masterList = category.getSubCategoriesList(uiState.getSubCategories())
                        subCategories = indices.mapNotNull { masterList.getOrNull(it) }
                    }
                    Spacer(Modifier.height(8.dp))
                    DetailEditText("Enter the business description *", description) { description = it }
                    Spacer(Modifier.height(8.dp))
                    DetailEditText("Enter the business services", services) { services = it }
                    Spacer(Modifier.height(8.dp))
                    Text14RegularBB("We need your business location. Use your device's GPS or enter your pincode. Click here *", Color.Blue, Modifier.clickable {
                        getDeviceLocationForBusiness(
                            {
                                address = it.getAddressString()
                                latitude = it.latitude.toString()
                                longitude = it.longitude.toString()
                                pincode = it.pincode.toString()
                            },{
                                address = it.display_name.toString()
                                latitude = it.lat.toString()
                                longitude = it.lon.toString()
                                pincode = it.address?.postcode.toString()
                            }
                        )
                    })
                    Spacer(Modifier.height(8.dp))
                    GVBButton(text = "Get Location") {
                        getDeviceLocationForBusiness(
                            {
                                address = it.getAddressString()
                                latitude = it.latitude.toString()
                                longitude = it.longitude.toString()
                                pincode = it.pincode.toString()
                            },{
                                address = it.display_name.toString()
                                latitude = it.lat.toString()
                                longitude = it.lon.toString()
                                pincode = it.address?.postcode.toString()
                            }
                        )
                    }
                    Spacer(Modifier.height(8.dp))
                    PincodeEditText(pincode, false, false) {}
                    Spacer(Modifier.height(8.dp))
                    AddressEditText(address) { address = it }
                    Spacer(Modifier.height(8.dp))
                    LatitudeEditText(latitude, false) { latitude = it }
                    Spacer(Modifier.height(8.dp))
                    LongitudeEditText(longitude, false) { longitude = it }
                    Spacer(Modifier.height(8.dp))
                    LazyRow(
                        modifier = Modifier.fillMaxWidth().padding(4.dp),
                        horizontalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        item {
                            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                uiState.getImage(image1.ifEmpty { ADD_URL.value() })?.let { imageBitmap -> CommonImage(imageBitmap, 100.dp, 100.dp, Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile1 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher1.launch()
                                        showLoading()
                                    })
                                }) }?: PlaceHolder(modifier = Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile1 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher1.launch()
                                        showLoading()
                                    })
                                })
                                Text14Regular("Select Image 1", black)
                            }
                        }
                        item {
                            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                uiState.getImage(image2.ifEmpty { ADD_URL.value() })?.let { imageBitmap -> CommonImage(imageBitmap, 100.dp, 100.dp, Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile2 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher2.launch()
                                        showLoading()
                                    })
                                }) }?: PlaceHolder(modifier = Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile2 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher2.launch()
                                        showLoading()
                                    })
                                })
                                Text14Regular("Select Image 2", black)
                            }
                        }
                        item {
                            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                uiState.getImage(image3.ifEmpty { ADD_URL.value() })?.let { imageBitmap -> CommonImage(imageBitmap, 100.dp, 100.dp, Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile3 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher3.launch()
                                        showLoading()
                                    })
                                }) }?: PlaceHolder(modifier = Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile3 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher3.launch()
                                        showLoading()
                                    })
                                })
                                Text14Regular("Select Image 3", black)
                            }
                        }
                        item {
                            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                uiState.getImage(image4.ifEmpty { ADD_URL.value() })?.let { imageBitmap -> CommonImage(imageBitmap, 100.dp, 100.dp, Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile4 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher4.launch()
                                        showLoading()
                                    })
                                }) }?: PlaceHolder(modifier = Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile4 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher4.launch()
                                        showLoading()
                                    })
                                })
                                Text14Regular("Select Image 4", black)
                            }
                        }
                        item {
                            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                uiState.getImage(image5.ifEmpty { ADD_URL.value() })?.let { imageBitmap -> CommonImage(imageBitmap, 100.dp, 100.dp, Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile5 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher5.launch()
                                        showLoading()
                                    })
                                }) }?: PlaceHolder(modifier = Modifier.clickable {
                                    chooseImage({
                                        showLoading()
                                        coroutineScope.launch {
                                            val selectedImage = captureImage()
                                            if (selectedImage != null) {
                                                launchDefault {
                                                    imageFile5 = Pair(resizeImage(selectedImage), "File")
                                                    hideLoading()
                                                }
                                            } else {
                                                hideLoading()
                                            }
                                        }
                                    }, {
                                        imagePickerLauncher5.launch()
                                        showLoading()
                                    })
                                })
                                Text14Regular("Select Image 5", black)
                            }
                        }
                    }
                    Spacer(Modifier.height(8.dp))
                    EmailEditText(email, label = "Enter Email *") { email = it }
                    Spacer(Modifier.height(8.dp))
                    MobileNumberEditText(phone1, label = "Enter Phone number 1 *") { phone1 = it }
                    Spacer(Modifier.height(8.dp))
                    MobileNumberEditText(phone2, label = "Enter Phone number 2") { phone2 = it }
                    Spacer(Modifier.height(8.dp))
                    WebsiteEditText("Enter business website", website) { website = it }
                    Spacer(Modifier.height(8.dp))
                    GMapEditText(gmap) { gmap = it }
                    Spacer(Modifier.height(8.dp))
                    FbEditText(fb) { fb = it }
                    Spacer(Modifier.height(8.dp))
                    InstaEditText(insta) { insta = it }
                    Spacer(Modifier.height(8.dp))
                    XEditText(x) { x = it }
                    Spacer(Modifier.height(8.dp))
                    LinkedInEditText(linkedIn) { linkedIn = it }
                    Spacer(Modifier.height(8.dp))
                    YoutubeEditText(youtube) { youtube = it }
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = if (isAdd) "Add Business" else "Save Business") {
                        val masterList = category.getSubCategoriesList(uiState.getSubCategories())
                        subCategories = selectedIndices.mapNotNull { masterList.getOrNull(it) }
                        addBusinessUI(false, logo, name, category, subCategories, description, services, address, pincode, latitude, longitude, image1, image2, image3, image4, image5, email, phone1, phone2, website, gmap, fb, insta, x, linkedIn, youtube, uiState.businessUiState.addEditBusiness.isBusinessDeleted())
                    }
                }
                if (uiState.businessUiState.addEditBusiness.isBusinessDeleted()) {
                    Spacer(Modifier.height(16.dp))
                    Text14Regular("This business has been requested for deletion and will be removed soon.", black)
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Undo Deletion") {
                        undoDeleteBusinessPopup {
                            val masterList = category.getSubCategoriesList(uiState.getSubCategories())
                            subCategories = selectedIndices.mapNotNull { masterList.getOrNull(it) }
                            addBusinessUI(false, logo, name, category, subCategories, description, services, address, pincode, latitude, longitude, image1, image2, image3, image4, image5, email, phone1, phone2, website, gmap, fb, insta, x, linkedIn, youtube, false)
                        }
                    }
                }
                if (isUserAdmin()) {
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Save Admin") {
                        val masterList = category.getSubCategoriesList(uiState.getSubCategories())
                        subCategories = selectedIndices.mapNotNull { masterList.getOrNull(it) }
                        addBusinessUI(true, logo, name, category, subCategories, description, services, address, pincode, latitude, longitude, image1, image2, image3, image4, image5, email, phone1, phone2, website, gmap, fb, insta, x, linkedIn, youtube, uiState.businessUiState.addEditBusiness.isBusinessDeleted())
                    }
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Delete MBusiness") {
                        deleteMBusinessUI(uiState.businessUiState.addEditBusiness)
                    }
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Admin Delete Business") {
                        val masterList = category.getSubCategoriesList(uiState.getSubCategories())
                        subCategories = selectedIndices.mapNotNull { masterList.getOrNull(it) }
                        addBusinessUI(true, logo, name, category, subCategories, description, services, address, pincode, latitude, longitude, image1, image2, image3, image4, image5, email, phone1, phone2, website, gmap, fb, insta, x, linkedIn, youtube, true)
                    }
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Admin Restore Business") {
                        val masterList = category.getSubCategoriesList(uiState.getSubCategories())
                        subCategories = selectedIndices.mapNotNull { masterList.getOrNull(it) }
                        addBusinessUI(true, logo, name, category, subCategories, description, services, address, pincode, latitude, longitude, image1, image2, image3, image4, image5, email, phone1, phone2, website, gmap, fb, insta, x, linkedIn, youtube, false)
                    }
                }
                Spacer(Modifier.weight(1f))
                Row(modifier = Modifier.fillMaxWidth().padding(top = 16.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text14RegularB("Privacy Policy", primary, Modifier.clickable { uriHandler.openUri(getPrivacyUrl()) })
                    Text14RegularB("Terms & Conditions", primary, Modifier.clickable { uriHandler.openUri(getTermsUrl()) })
                }
            }
        }
        logoFile?.let {
            Surface(
                modifier = Modifier.fillMaxSize(),
                color = MaterialTheme.colors.background
            ) {
                Box(
                    modifier = Modifier.fillMaxSize().background(Color.Black).padding(16.dp)
                ) {
                    Column(modifier = Modifier.padding(55.dp).fillMaxSize().pointerInput(Unit) {}) {
                        com.gsb.vyapar.bhagya.presentation.common.image.ZoomableImage(it.first.toComposeImageBitmap())
                    }
                    Row(modifier = Modifier.align(Alignment.BottomCenter).padding(16.dp)) {
                        CommonImage(rotateleft, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                logoFile = Pair(rotateLeft(logoFile!!.first), logoFile!!.second)
                            }
                        })
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Cancel") {
                            logoFile = null
                        }
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Upload") {
                            val imageData = it.first
                            val fileNmae = it.second
                            logoFile = null
                            showLoading()
                            uploadImage(imageData, fileNmae) {
                                logo = it
                                hideLoading()
                            }
                        }
                        Spacer(Modifier.width(8.dp))
                        CommonImage(rotateright, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                logoFile = Pair(rotateRight(logoFile!!.first), logoFile!!.second)
                            }
                        })
                    }
                    CommonImage(close, 30.dp, 30.dp, Modifier.align(Alignment.TopEnd).clickable { logoFile = null })
                }
            }
        }
        imageFile1?.let {
            Surface(
                modifier = Modifier.fillMaxSize(),
                color = MaterialTheme.colors.background
            ) {
                Box(
                    modifier = Modifier.fillMaxSize().background(Color.Black).padding(16.dp)
                ) {
                    Column(modifier = Modifier.padding(55.dp).fillMaxSize().pointerInput(Unit) {}) {
                        com.gsb.vyapar.bhagya.presentation.common.image.ZoomableImage(it.first.toComposeImageBitmap())
                    }
                    Row(modifier = Modifier.align(Alignment.BottomCenter).padding(16.dp)) {
                        CommonImage(rotateleft, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile1 = Pair(rotateLeft(imageFile1!!.first), imageFile1!!.second)
                            }
                        })
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Cancel") {
                            imageFile1 = null
                        }
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Upload") {
                            val imageData = it.first
                            val fileNmae = it.second
                            imageFile1 = null
                            showLoading()
                            uploadImage(imageData, fileNmae) {
                                image1 = it
                                hideLoading()
                            }
                        }
                        Spacer(Modifier.width(8.dp))
                        CommonImage(rotateright, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile1 = Pair(rotateRight(imageFile1!!.first), imageFile1!!.second)
                            }
                        })
                    }
                    CommonImage(close, 30.dp, 30.dp, Modifier.align(Alignment.TopEnd).clickable { imageFile1 = null })
                }
            }
        }
        imageFile2?.let {
            Surface(
                modifier = Modifier.fillMaxSize(),
                color = MaterialTheme.colors.background
            ) {
                Box(
                    modifier = Modifier.fillMaxSize().background(Color.Black).padding(16.dp)
                ) {
                    Column(modifier = Modifier.padding(55.dp).fillMaxSize().pointerInput(Unit) {}) {
                        com.gsb.vyapar.bhagya.presentation.common.image.ZoomableImage(it.first.toComposeImageBitmap())
                    }
                    Row(modifier = Modifier.align(Alignment.BottomCenter).padding(16.dp)) {
                        CommonImage(rotateleft, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile2 = Pair(rotateLeft(imageFile2!!.first), imageFile2!!.second)
                            }
                        })
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Cancel") {
                            imageFile2 = null
                        }
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Upload") {
                            val imageData = it.first
                            val fileNmae = it.second
                            imageFile2 = null
                            showLoading()
                            uploadImage(imageData, fileNmae) {
                                image2 = it
                                hideLoading()
                            }
                        }
                        Spacer(Modifier.width(8.dp))
                        CommonImage(rotateright, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile2 = Pair(rotateRight(imageFile2!!.first), imageFile2!!.second)
                            }
                        })
                    }
                    CommonImage(close, 30.dp, 30.dp, Modifier.align(Alignment.TopEnd).clickable { imageFile2 = null })
                }
            }
        }
        imageFile3?.let {
            Surface(
                modifier = Modifier.fillMaxSize(),
                color = MaterialTheme.colors.background
            ) {
                Box(
                    modifier = Modifier.fillMaxSize().background(Color.Black).padding(16.dp)
                ) {
                    Column(modifier = Modifier.padding(55.dp).fillMaxSize().pointerInput(Unit) {}) {
                        com.gsb.vyapar.bhagya.presentation.common.image.ZoomableImage(it.first.toComposeImageBitmap())
                    }
                    Row(modifier = Modifier.align(Alignment.BottomCenter).padding(16.dp)) {
                        CommonImage(rotateleft, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile3 = Pair(rotateLeft(imageFile3!!.first), imageFile3!!.second)
                            }
                        })
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Cancel") {
                            imageFile3 = null
                        }
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Upload") {
                            val imageData = it.first
                            val fileNmae = it.second
                            imageFile3 = null
                            showLoading()
                            uploadImage(imageData, fileNmae) {
                                image3 = it
                                hideLoading()
                            }
                        }
                        Spacer(Modifier.width(8.dp))
                        CommonImage(rotateright, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile3 = Pair(rotateRight(imageFile3!!.first), imageFile3!!.second)
                            }
                        })
                    }
                    CommonImage(close, 30.dp, 30.dp, Modifier.align(Alignment.TopEnd).clickable { imageFile3 = null })
                }
            }
        }
        imageFile4?.let {
            Surface(
                modifier = Modifier.fillMaxSize(),
                color = MaterialTheme.colors.background
            ) {
                Box(
                    modifier = Modifier.fillMaxSize().background(Color.Black).padding(16.dp)
                ) {
                    Column(modifier = Modifier.padding(55.dp).fillMaxSize().pointerInput(Unit) {}) {
                        com.gsb.vyapar.bhagya.presentation.common.image.ZoomableImage(it.first.toComposeImageBitmap())
                    }
                    Row(modifier = Modifier.align(Alignment.BottomCenter).padding(16.dp)) {
                        CommonImage(rotateleft, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile4 = Pair(rotateLeft(imageFile4!!.first), imageFile4!!.second)
                            }
                        })
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Cancel") {
                            imageFile4 = null
                        }
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Upload") {
                            val imageData = it.first
                            val fileNmae = it.second
                            imageFile4 = null
                            showLoading()
                            uploadImage(imageData, fileNmae) {
                                image4 = it
                                hideLoading()
                            }
                        }
                        Spacer(Modifier.width(8.dp))
                        CommonImage(rotateright, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile4 = Pair(rotateRight(imageFile4!!.first), imageFile4!!.second)
                            }
                        })
                    }
                    CommonImage(close, 30.dp, 30.dp, Modifier.align(Alignment.TopEnd).clickable { imageFile4 = null })
                }
            }
        }
        imageFile5?.let {
            Surface(
                modifier = Modifier.fillMaxSize(),
                color = MaterialTheme.colors.background
            ) {
                Box(
                    modifier = Modifier.fillMaxSize().background(Color.Black).padding(16.dp)
                ) {
                    Column(modifier = Modifier.padding(55.dp).fillMaxSize().pointerInput(Unit) {}) {
                        com.gsb.vyapar.bhagya.presentation.common.image.ZoomableImage(it.first.toComposeImageBitmap())
                    }
                    Row(modifier = Modifier.align(Alignment.BottomCenter).padding(16.dp)) {
                        CommonImage(rotateleft, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile5 = Pair(rotateLeft(imageFile5!!.first), imageFile5!!.second)
                            }
                        })
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Cancel") {
                            imageFile5 = null
                        }
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Upload") {
                            val imageData = it.first
                            val fileNmae = it.second
                            imageFile5 = null
                            showLoading()
                            uploadImage(imageData, fileNmae) {
                                image5 = it
                                hideLoading()
                            }
                        }
                        Spacer(Modifier.width(8.dp))
                        CommonImage(rotateright, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile5 = Pair(rotateRight(imageFile5!!.first), imageFile5!!.second)
                            }
                        })
                    }
                    CommonImage(close, 30.dp, 30.dp, Modifier.align(Alignment.TopEnd).clickable { imageFile5 = null })
                }
            }
        }
    }
    LaunchedEffect(Unit) {
        val business = uiState.businessUiState.addEditBusiness
        logo = business.getLogo()
        name = business.getName()
        category = uiState.getCategories().getCategoriesList().find { it.id.toString() == business.getCategoryId() } ?: Category()
        selectedIndex = uiState.getCategories().getCategoriesList().map { it.name }.indexOf(category.name)
        val restoredList = business.getSubCategoryIds().split(", ").mapNotNull { it.toIntOrNull() }
        subCategories = category.getSubCategoriesList(uiState.getSubCategories()).filter { restoredList.contains(it.id.toInt()) }
        val masterList = category.getSubCategoriesList(uiState.getSubCategories())
        val subcategoryIds = subCategories.map { it.id }.toSet()
        selectedIndices = masterList.mapIndexedNotNull { index, item -> if (item.id in subcategoryIds) index else null }
        description = business.getDescription()
        services = business.getServices()
        address = business.getAddress()
        pincode = business.getPincode()
        latitude = business.getLatitude()
        longitude = business.getLongitude()
        image1 = business.getImage1()
        image2 = business.getImage2()
        image3 = business.getImage3()
        image4 = business.getImage4()
        image5 = business.getImage5()
        email = business.getEmail()
        phone1 = business.getPhone1()
        phone2 = business.getPhone2()
        website = business.getWebsite()
        gmap = business.getMap()
        fb = business.getFacebook()
        insta = business.getInstagram()
        x = business.getX()
        linkedIn = business.getLinkedIn()
        youtube = business.getYoutube()
        isAdd = name.isEmpty()
    }
}